/* eslint-disable camelcase */
import React from 'react';
import {
  CopyIcon,
  CountryCropMapIcon,
  FleetTelematicsIcon,
  IntegrationsIcon,
  CropManagementIcon,
  FarmOperationsIcon,
  ApiCustomDashboardIcon,
  SystemConfigurationIcon,
  ProductServicesIcon,
  ServiceDeskIcon,
  WMSIcon,
  LandParcelIcon,
  MobileAppIcon,
} from 'components/cwo-icons';

const cwoModuleConfig = {
  telematics: {
    icon: <FleetTelematicsIcon />,
  },
  integrations: {
    icon: <IntegrationsIcon />,
  },
  other: {
    icon: <CopyIcon color="#000000" />,
  },
  crop_management: {
    icon: <CropManagementIcon />,
  },
  farm_operations: {
    icon: <FarmOperationsIcon />,
  },
  api: {
    icon: <ApiCustomDashboardIcon />,
  },
  system_configuration: {
    icon: <SystemConfigurationIcon />,
  },
  p_plus_services: {
    icon: <ProductServicesIcon />,
  },
  crop_map: {
    icon: <CountryCropMapIcon />,
  },
  wms: {
    icon: <WMSIcon color="#000000" />,
  },
  land_parcels: {
    icon: <LandParcelIcon color="#000000" />,
  },
  mobile_apps: {
    icon: <MobileAppIcon color="#000000" />,
  },
  service_desk: {
    icon: <ServiceDeskIcon color="#000000" size={24} />,
  },
};
export default cwoModuleConfig;
